// Clinic Configuration for Todays Dental West Columbia
// This file contains all clinic-specific values used across the application

export const CLINIC_CONFIG = {
  // Basic Information
  clinicName: "Todays Dental West Columbia",
  clinicId: "todaysdentalwestcolumbia",
  clinicUrl: "https://todaysdentalwestcolumbia.com",
  // Contact Information
  phoneNumber: "803-233-8177",
  phoneNumberRaw: "+18032338177", // For tel: and sms: links
  email: "Dentist@TodaysDentalWestColumbia.com",
  aiAgent: "wss://ws.todaysdentalinsights.com/ai-agents?clinicId=todaysdentalwestcolumbia&agentId=4223dab8-46fa-4410-b92b-451d96cada09",
  voiceApiUrl: "https://apig.todaysdentalinsights.com/ai-agents/public/clinic/todaysdentalwestcolumbia/voice",

  // Location
  address: "115 Medical Cir, West Columbia, SC 29169, USA",
  addressShort: "115 Medical Cir, West Columbia, SC 29169",
  city: "West Columbia",
  hcity: "west-columbia",
  state: "South Carolina",
  stateShortForm: "SC",
  PostalCode: "29169",
  // Map Links
  mapUrl: "https://maps.app.goo.gl/NfpA3W9nsMdxC2gy5",

  // Embedded Map
  iframe: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3178.390008530779!2d-81.11585492428567!3d34.00299017317554!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f8bdf57450ab77%3A0x913e1962b19bff24!2sTodays%20Dental%20%40%20West%20Columbia!5e1!3m2!1sen!2sin!4v1756790441603!5m2!1sen!2sin',
  iframeTitle: "Todays Dental West Columbia",

  //membership
  membership: "https://member.kleer.com/?slug=CP3F",

  // Sunbit
  sunbitUrl: "https://apply.sunbit.com/TodaysDentalatWestColumbia",

  // Cherry
  cherryUrl: "https://pay.withcherry.com/todays-dental-at-west-columbia?utm_source=practice&utm_medium=email&m=57193",


  // Analytics
  gaMeasurementId: "G-H5NH292Q9B",
  clarityProjectId: "prcle83ice",

  // API Configuration
  apiBaseUrl: "https://apig.todaysdentalinsights.com/patientportal/todaysdentalwestcolumbia",
  callbackUrl: "https://apig.todaysdentalinsights.com/callback/todaysdentalwestcolumbia",
  clinicHoursUrl: "https://apig.todaysdentalinsights.com/clinic-hours/hours/todaysdentalwestcolumbia",
  websocketUrl: "wss://ws.todaysdentalinsights.com/chat",
  webAssistantUrl: "https://todaysdentalwestcolumbia.web-assistant.tensorlinks.app/",

  // Social Media Links
  social: {
    facebook: "https://www.facebook.com/TodaysDentalWestColumbia",
    instagram: "https://www.instagram.com/todaysdental_westcolumbia/",
    twitter: "https://x.com/Td_Westcolumbia",
    linkedin: "https://www.linkedin.com/company/108141826/admin/?lipi=urn%3Ali%3Apage%3Ad_flagship3_feed%3BZHzZHS4UQLaEyel%2BGoze8g%3D%3D",
    youtube: "https://www.youtube.com/@todaysdentalwestcolumbia",
  },

  // Review Links (for Patient Reviews page)
  reviewLinks: {
    google: "https://business.google.com/n/2296070577534636829/profile?hl=en-GB&fid=10465830495732891428",
    facebook: "https://www.facebook.com/TodaysDentalWestColumbia/",
    yelp: "https://www.yelp.com/biz/todays-dental-west-columbia-west-columbia-4",
  },

  // Open Dental Configuration
  defaultProvNum: 1,
  defaultOpNum: 14,

  // Appointment Types Configuration
  appointmentTypes: [
    {
      value: 'New patient emergency/other',
      label: 'New patient emergency/other',
      duration: 30,
      opNum: 12,
      AppointmentTypeNum: 12
    },
    {
      value: 'Existing patient emergency/other',
      label: 'Existing patient emergency/other',
      duration: 30,
      opNum: 14,
      AppointmentTypeNum: 18
    },
    {
      value: 'Existing patient current treatment Plan',
      label: 'Existing patient current treatment Plan',
      duration: 30,
      opNum: 14,
      AppointmentTypeNum: 20
    }
  ],


  // Twilio Configuration
  twilioPhoneNumber: "18036183441",

  // Helper functions for common patterns
  getTelLink: function () {
    return `tel:${this.phoneNumberRaw}`;
  },

  getSmsLink: function (body?: string) {
    const bodyText = body || "Hello%20";
    return `sms:+${this.twilioPhoneNumber}?body=${bodyText}`;
  },

  getEmailLink: function (subject?: string, body?: string) {
    const params = [];
    if (subject) params.push(`subject=${encodeURIComponent(subject)}`);
    if (body) params.push(`body=${encodeURIComponent(body)}`);
    const queryString = params.length > 0 ? `?${params.join('&')}` : '';
    return `mailto:${this.email}${queryString}`;
  },
};

// Export individual items for convenience
export const {
  clinicName,
  clinicId,
  phoneNumber,
  phoneNumberRaw,
  email,
  address,
  addressShort,
  city,
  state,
  stateShortForm,
  mapUrl,
  iframe,
  iframeTitle,
  clarityProjectId,
  apiBaseUrl,
  callbackUrl,
  clinicHoursUrl,
  websocketUrl,
  social,
  reviewLinks,
  defaultProvNum,
  defaultOpNum,
  appointmentTypes,
} = CLINIC_CONFIG;

export default CLINIC_CONFIG;  
